import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://whitecurve.onrender.com/api';

// Set up the base URL for your backend API
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Example: Get all items
export const getItems = async () => {
  try {
    console.log('[api] GET /items');
    const response = await api.get('/items');
    console.log('[api] Response:', response.data);
    return response.data;
  } catch (error) {
    console.error('[api] Error in getItems:', error);
    throw formatApiError(error);
  }
};

// Example: Create a new item
export const createItem = async (itemData) => {
  try {
    console.log('[api] POST /items', itemData);
    const response = await api.post('/items', itemData);
    console.log('[api] Response:', response.data);
    return response.data;
  } catch (error) {
    console.error('[api] Error in createItem:', error);
    throw formatApiError(error);
  }
};

// Upload document(s)
export const uploadDocument = async (files, options = {}) => {
  const formData = new FormData();
  // Accepts FileList or array
  const fileArray = Array.from(files);
  fileArray.forEach(file => formData.append('files', file));
  console.log('[api] POST /upload', fileArray);
  try {
    const response = await axios.post(`${API_BASE_URL}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      ...options,
    });
    console.log('[api] Upload response:', response.data);
    return response.data;
  } catch (error) {
    console.error('[api] Error in uploadDocument:', error);
    throw formatApiError(error);
  }
};

// Generate mock paper
export const generateMockPaper = async (data) => {
  console.log('[api] POST /generate-mock-paper', data);
  try {
    const response = await axios.post(`${API_BASE_URL}/generate-mock-paper`, data);
    console.log('[api] Response:', response.data);
    return response.data;
  } catch (error) {
    console.error('[api] Error in generateMockPaper:', error);
    throw formatApiError(error);
  }
};

// Generate study guide
export const generateStudyGuide = async (data) => {
  console.log('[api] POST /generate-study-guide', data);
  try {
    const response = await axios.post(`${API_BASE_URL}/generate-study-guide`, data);
    console.log('[api] Response:', response.data);
    return response.data;
  } catch (error) {
    console.error('[api] Error in generateStudyGuide:', error);
    throw formatApiError(error);
  }
};

// Generate important topics
export const generateImportantTopics = async (data) => {
  console.log('[api] POST /generate-important-topics', data);
  try {
    const response = await axios.post(`${API_BASE_URL}/generate-important-topics`, data);
    console.log('[api] Response:', response.data);
    return response.data;
  } catch (error) {
    console.error('[api] Error in generateImportantTopics:', error);
    throw formatApiError(error);
  }
};

// Generate exam expectations
export const generateExamExpectations = async (data) => {
  console.log('[api] POST /generate-exam-expectations', data);
  try {
    const response = await axios.post(`${API_BASE_URL}/generate-exam-expectations`, data);
    console.log('[api] Response:', response.data);
    return response.data;
  } catch (error) {
    console.error('[api] Error in generateExamExpectations:', error);
    throw formatApiError(error);
  }
};

// Helper to get Gemini config from localStorage
function getGeminiConfig() {
  const config = localStorage.getItem('geminiConfig');
  return config ? JSON.parse(config) : { temperature: 0.7, maxTokens: 1024 };
}

// Generate a resource (e.g., mockPaper, studyGuide) for a document
export const generateResource = async (documentId, resourceType) => {
  try {
    const { temperature, maxTokens } = getGeminiConfig();
    console.log('[api] POST /generate/' + resourceType, { documentId, temperature, maxTokens });
    const response = await api.post(`/generate/${resourceType}`, { documentId, temperature, maxTokens });
    console.log('[api] Response:', response.data);
    return response.data;
  } catch (error) {
    console.error('[api] Error in generateResource:', error);
    throw formatApiError(error);
  }
};

// Helper to format API errors
function formatApiError(error) {
  let message = 'An unexpected error occurred.';
  if (error.response && error.response.data && error.response.data.error) {
    message = error.response.data.error;
  } else if (error.message) {
    message = error.message;
  }
  return { message };
}

// Curve Ai chat
export const curveAiChat = async (message, documentId, history = []) => {
  try {
    const response = await api.post('/curve-ai/chat', { message, documentId, history });
    return response.data;
  } catch (error) {
    console.error('[api] Error in curveAiChat:', error);
    throw formatApiError(error);
  }
};

// Add more API functions as needed

export default api; 
